import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter71.json";
import Head from "next/head";

export default function Chapter_71() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Central Doctrine | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="The Divine Infinite Being: Pathways to Ultimate Truth"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Our curriculum blends Tarot, Astrology, Eastern philosophy, Western Mysteries, quantum theory, and sacred theurgy. Rooted in the wisdom of the Bhagavad Gita, Gospel of Thomas, and Tao Te Ching, we guide seekers toward the Divine Infinite Being. Integrating Iamblichus’ philosophy, Jungian insight, and cosmic science, our teachings offer a transformative path to spiritual awakening."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=71"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=71"
        ></meta>
        <meta
          name="twitter:title"
          content="The Divine Infinite Being: Pathways to Ultimate Truth"
        ></meta>
        <meta
          name="twitter:description"
          content="We unite mystical traditions, sacred texts, and modern science into a transformative spiritual curriculum. From Tarot to string theory, Bhagavad Gita to the Gospel of Thomas, our school offers a universal gateway to the Divine Infinite Being. Guided by Iamblichus’ philosophy, our teachings illuminate the timeless principles shaping reality and the seeker’s journey."
        ></meta>

        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=71" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
